// UI-test (Alex 2026-10-16): appen går aldrig ut på nätet. Varje anrop mot backend får ett låtsassvar i webbläsaren
// (live/uitest/router.js), så att teamet kan klicka runt i hela appen utan backend. Läget 'av' | 'backend' | 'ui':
// 'backend' är dagens Testläge (testkunden i GHL, live/testlage.js), 'ui' är det här. Filen importerar inget:
// konto.js läser den före allt annat.
const LAGE = 'mb_uitest_lage';
const SEED = 'mb_uitest_seed';
/** Fliken kör rundturens Första samtalet (tour/samtal.js sätter den, app/Testlage.jsx och samtalKor läser den). */
export const KAPITEL_FLAGGA = 'mb_rundtur_kapitel';
const LAGER = 'mb_uitest_lager_';
const STANDARD_SEED = 20261016;
// fliknycklarna i konto.js (kund, Visa som) hör till ett läge: byter läget glöms de, så att en riktig kund aldrig står kvar i UI-test
const ROLL = 'mb_uitest_roll';
const FLIKNYCKLAR = ['mb_v2_kund', 'mb_v2_visa_som', ROLL, 'mb_uitest_klocka'];   // rollen och klockan hör också till läget: Avsluta nollställer dem

const lasS = (k) => { try { return window.sessionStorage.getItem(k); } catch { return null; } };
const sattS = (k, v) => { try { if (v == null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, String(v)); } catch { /* utan lagring gäller läget bara tills sidan laddas om */ } };

let minneLage = null;   // utan sessionStorage
const lage = () => lasS(LAGE) || minneLage || 'av';
export const iUiTest = () => lage() === 'ui';
/** Kör fliken Första samtalet (rundturen, tour/samtal.js)? Flaggan sätts i fliken och gäller bara i UI-testläget. */
export const samtalKor = () => lage() === 'ui' && lasS(KAPITEL_FLAGGA) === 'samtal';
export const testLage = lage;

/* Låtsassvaren (live/uitest/, 53 kB gzip) hämtas först i UI-testet, aldrig för en riktig bokare (autoresearch 2026-10-23) */
let svaren = null;
export function laddaUiSvar() {
  if (!svaren) svaren = import('./uitest/alla.js').then(() => import('./uitest/router.js'));
  return svaren;
}
export const uiSvarSenare = (...a) => laddaUiSvar().then((r) => r.uiSvar(...a));

function stadaFlik() { FLIKNYCKLAR.forEach((k) => sattS(k, null)); }

/** Appens egen lagring (mb2.* och chefsloggen). I UI-testet är den fliken (sessionStorage): låtsasdata når aldrig en annan flik
    (storage-eventet), blir inte kvar när fliken stängs, och riktig data syns inte. Riktigt läge: localStorage som förut. */
export const lagring = () => (iUiTest() ? window.sessionStorage : window.localStorage);

function stadaAdress() {
  try {
    const u = new URL(window.location.href);
    if (u.searchParams.has('test')) { u.searchParams.delete('test'); window.history.replaceState(null, '', u.pathname + u.search + u.hash); }
  } catch { /* adressen får stå kvar */ }
}
const laddaOm = () => { try { window.location.reload(); } catch { /* inget fönster */ } };

/** Byt läge och ladda om sidan. Från eller till 'ui' glöms kunden och Visa som, och ?test= tas bort ur adressen. */
export function sattLage(l, { omladdning = true } = {}) {
  if (!['av', 'backend', 'ui'].includes(l)) return;
  if (l !== lage() && (l === 'ui' || lage() === 'ui')) stadaFlik();
  minneLage = l;
  sattS(LAGE, l);
  stadaAdress();
  if (omladdning) laddaOm();
}

// En länk med ?test=ui slår på läget direkt (innan konto.js läser kunden).
try {
  if (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('test') === 'ui' && !iUiTest()) {
    stadaFlik(); sattS(LAGE, 'ui'); minneLage = 'ui';
  }
} catch { /* ingen adress */ }

/** Taket i UI-testet (Alex 2026-10-18, kort 5): samma form som /punkt/tak, påhittat men fast per punkt, så leadkortet aldrig står tomt. */
export function uiTak({ lat, lng }) {
  const h = Math.abs(Math.sin(lat * 12.9898 + lng * 78.233) * 43758.5453) % 1;
  const yta = Math.round(90 + h * 140);
  return { tak: { delar: [{ azimut: Math.round(120 + h * 130), yta_m2: Math.round(yta * 0.6) }, { azimut: Math.round(300 + h * 40) % 360, yta_m2: Math.round(yta * 0.4) }], takyta_m2: yta, skugga_procent: Math.round(h * 40) } };
}

/** Bokades dagssiffror i UI-testet: dagen börjar med lite gjort, så att inget står på 0 (Alex 2026-10-18). Null utanför UI-testet. */
export const uiStartStat = () => (iUiTest() ? { flyttade: 3, dagar: 8, spar: 95 } : null);

/* ---------- Rollen: vem UI-testet låtsas vara (live/uitest/roller.js har listan) ---------- */
/** Vald roll-id ('admin', 'chef', 'bokare') eller null = Admin. */
export const lasRoll = () => lasS(ROLL);
/** Byt roll och ladda om sidan. Börja om och Blanda om rör inte rollen. */
export function sattRoll(id) { sattS(ROLL, id === 'admin' ? null : id); laddaOm(); }

/* ---------- Slumpen: seedad, så att samma seed ger samma låtsasdata ---------- */
export const seed = () => { const n = Number(lasS(SEED)); return Number.isFinite(n) && n > 0 ? n : STANDARD_SEED; };

function mulberry32(a) {
  return () => {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
let gen = null;
let genSeed = null;
/** Nästa tal 0 till 1 ur seeden. Sidan startar om från seeden vid varje laddning. */
export function slump() {
  if (gen === null || genSeed !== seed()) { genSeed = seed(); gen = mulberry32(genSeed); }
  return gen();
}

/* ---------- Låtsaslagret: det UI-testet "sparar" (lever tills Börja om) ---------- */
export const lager = {
  hamta(namn, fallback) { try { const v = lasS(LAGER + namn); return v == null ? fallback : JSON.parse(v); } catch { return fallback; } },
  satt(namn, v) { sattS(LAGER + namn, JSON.stringify(v)); },
  tom() {
    try { Object.keys(window.sessionStorage).filter((k) => k.startsWith(LAGER)).forEach((k) => window.sessionStorage.removeItem(k)); } catch { /* inget att tömma */ }
  },
  /** Alla poster som de ligger (nyckel till text), så att Första samtalet kan lägga undan en pågående UI-tests låtsasdata och sätta tillbaka den. */
  raa() {
    const o = {};
    try { Object.keys(window.sessionStorage).filter((k) => k.startsWith(LAGER)).forEach((k) => { o[k] = window.sessionStorage.getItem(k); }); } catch { /* inget att läsa */ }
    return o;
  },
  /** Skriver tillbaka poster ur raa() (och andra nycklar i fliken). */
  aterstall(poster) {
    try { Object.entries(poster || {}).forEach(([k, v]) => window.sessionStorage.setItem(k, v)); } catch { /* fullt: kapitlet slutar utan den gamla låtsasdatan */ }
  },
};

/** Standard-seed och tomt låtsaslager, sedan ny laddning. */
export function borjaOm() { sattS(SEED, STANDARD_SEED); lager.tom(); gen = null; laddaOm(); }
/** Ny slumpad seed (aldrig standard) och tomt låtsaslager, sedan ny laddning. */
export function blandaOm() {
  let n;
  do { n = 1 + Math.floor(Math.random() * 2147483646); } while (n === STANDARD_SEED || n === seed());
  sattS(SEED, n); lager.tom(); gen = null; laddaOm();
}

/* ---------- Klockan (kort 9, Alex 2026-10-18): spola tiden. Ny dag, ny data ---------- */
// Appen tror att det är en annan dag: Date.now() och new Date() flyttas med skiftet, så låtsasdatan byggs kring den nya dagen.
// Låtsaslagret (det du själv gjort) står kvar med sina datum. Skiftet hör till fliken, som läget.
const KLOCKA = 'mb_uitest_klocka';
const RiktigDate = Date;
export const klockSkift = () => { const n = Number(lasS(KLOCKA)); return Number.isFinite(n) ? n : 0; };
const sattSkift = (ms) => { if (!Number.isFinite(ms)) return; sattS(KLOCKA, ms ? Math.round(ms) : null); laddaOm(); };
/** Spola fram (dagar > 0) eller bakåt, och ladda om. Räknar i kalenderdagar, så klockslaget står still över sommartidsbytet. */
export function spolaDagar(dagar) {
  const nu = RiktigDate.now();
  const mal = new RiktigDate(nu + klockSkift());
  mal.setDate(mal.getDate() + dagar);
  sattSkift(mal.getTime() - nu);
}
/** Gå till en viss dag (YYYY-MM-DD) med samma klockslag som nu, och ladda om. */
export function gaTillDag(iso) {
  const ms = skiftTill(iso);
  if (ms != null) sattSkift(ms);
}
/** Skiftet (ms) till en dag YYYY-MM-DD med samma klockslag som nu, eller null för ett ogiltigt datum. */
function skiftTill(iso) {
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return null;
  const nu = new RiktigDate(RiktigDate.now());
  const ms = new RiktigDate(y, m - 1, d, nu.getHours(), nu.getMinutes(), nu.getSeconds()).getTime() - nu.getTime();
  return Number.isFinite(ms) ? ms : null;
}
export const tillbakaTillIdag = () => sattSkift(0);

/** Byt ut Date mot en som går skift ms före. Datum med argument (new Date(x), Date.UTC) är orörda. */
export function installeraKlocka(skift, g = globalThis) {
  if (!skift || g.Date.__uitestKlocka) return;
  const R = g.Date;
  function Spolad(...a) {
    if (!(this instanceof Spolad)) return new R(R.now() + skift).toString();
    return a.length ? new R(...a) : new R(R.now() + skift);
  }
  Spolad.prototype = R.prototype;
  Spolad.now = () => R.now() + skift;
  Spolad.parse = R.parse;
  Spolad.UTC = R.UTC;
  Spolad.__uitestKlocka = true;
  g.Date = Spolad;
}
/* ---------- Delad länk (kort 8, Alex 2026-10-18): ?test=ui&roll=chef&dag=2026-10-21&testkund=…&seed=… ----------
   Visa och få feedback på exakt samma läge. Länken läses före klockan och kunden, sedan städas adressen (test=ui står kvar). */
const DELA = ['roll', 'dag', 'testkund', 'seed'];   // inte 'kund': den öppnar v1 (entry.js V1_LANKAR)
const KUND_NYCKEL = 'mb_v2_kund';   // samma nyckel som konto.js
export function lasDeladLank(g = typeof window !== 'undefined' ? window : null) {
  try {
    const u = new URL(g.location.href);
    const q = u.searchParams;
    if (q.get('test') !== 'ui' || !DELA.some((k) => q.has(k))) return;
    if (['admin', 'chef', 'bokare'].includes(q.get('roll'))) sattS(ROLL, q.get('roll') === 'admin' ? null : q.get('roll'));
    if (Number(q.get('seed')) > 0) sattS(SEED, Number(q.get('seed')));
    if (q.get('testkund')) sattS(KUND_NYCKEL, q.get('testkund'));
    if (q.has('dag')) { const ms = skiftTill(q.get('dag')); if (ms != null) sattS(KLOCKA, ms ? Math.round(ms) : null); }
    DELA.forEach((k) => q.delete(k));
    g.history.replaceState(null, '', u.pathname + u.search + u.hash);
  } catch { /* trasig länk: UI-testet startar som vanligt */ }
}
if (iUiTest()) lasDeladLank();

/** Länken till läget just nu: sidan, rollen, dagen (bara om spolad), kunden och seeden. */
export function deladLank(g = window) {
  const u = new URL(g.location.origin + g.location.pathname);
  u.searchParams.set('test', 'ui');
  if (lasS(ROLL)) u.searchParams.set('roll', lasS(ROLL));
  if (klockSkift()) {
    const d = new RiktigDate(RiktigDate.now() + klockSkift());
    u.searchParams.set('dag', `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
  }
  if (lasS(KUND_NYCKEL)) u.searchParams.set('testkund', lasS(KUND_NYCKEL));
  if (seed() !== STANDARD_SEED) u.searchParams.set('seed', seed());
  return u.toString() + g.location.hash;
}

if (iUiTest() && process.env.NODE_ENV !== 'test') installeraKlocka(klockSkift());

/* ---------- Skyddsnät: i UI-test når inget fetch() backend ---------- */
// De enskilda `if (iUiTest())`-vakterna ger snyggare reservsvar. Det här fångar det som glömts: anrop mot /api/ eller BACKEND avvisas och loggas.
export function sparraBackendFetch() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || window.fetch.__uitestSparr) return;
  const riktig = window.fetch.bind(window);
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  const sparrad = (indata) => {
    try {
      const adress = typeof indata === 'string' ? indata : (indata && indata.url) || String(indata);
      const u = new URL(adress, window.location.origin);
      /* elpriset är ett öppet API utanför vår backend: får gå även i UI-test, annars syns aldrig spotpris-lappen */
      if (u.hostname === 'www.elprisetjustnu.se') return false;
      return (backend && adress.startsWith(backend)) || u.pathname.startsWith('/api/');
    } catch { return false; }
  };
  const ny = (indata, ...rest) => {
    if (!sparrad(indata)) return riktig(indata, ...rest);
    const nyckel = `fetch ${typeof indata === 'string' ? indata : (indata && indata.url) || ''}`;
    (window.__uitestSaknas = window.__uitestSaknas || new Set()).add(nyckel);
    console.warn('[uitest] blockerade anrop mot backend', nyckel);
    return Promise.reject(new Error(`UI-test: anrop mot backend blockerat (${nyckel})`));
  };
  ny.__uitestSparr = true;
  window.fetch = ny;
}
// i jest installeras nätet av testet självt: övriga tester ersätter global.fetch med egna spioner
if (iUiTest() && process.env.NODE_ENV !== 'test') sparraBackendFetch();
